/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * This module has two utilities:
 *
 * This module create getters and setters for every property of the object passed as first argument and also
 * implement the "go" method which executed an arbitrary function passing all the property values.
 *
 * To create the getters and setters the first argument of the constructor should be an object with the
 * following accepted properties:
 *
 *  - name: String Custom name of the property. If isn't define the name of the property will be used.
 *  - validator: Function(value) If the value isn't valid this function should throw an Error,
 *      otherwise it should return the value validated
 *  - defaultValue: Function() This function have to return the default value
 *  - converter: Function(value) The returned value of this function will be used
 *
 * This is an example of configurations this module could take:
 * @example
 * ```js
 * var properties = {
 *   city: {
 *     name: 'bestCity',
 *     validator: function (name) {
 *       if (typeof name !== 'string' || name.length === 0) throw new Error('City name is not valid');
 *       return name;
 *     },
 *     converter: function (name) {
 *       return name.toLowerCase();
 *     },
 *     defaultValue: function() {
 *       return 'Lodz';
 *     }
 *   }
 * }
 * var config = require('chain')(properties);
 * config.city(); // prints "lodz"
 * config.city('Torun'); // prints "torun"
 * config.city(); // prints "torun"
 * ```
 *
 * Take notice the converter function is always executed, even for the default value.
 *
 * As second argument a function will be expected and this function will be executed using the "go" method
 * returned by this constructor.
 * The additional functions returned by this constructor are: "go", "callback" and "fail".
 *
 * The "go" function will execute the function passed as second argument of the constructor which should
 * implement the next signature: goFunction(properties, callback) .
 *
 * Is expected that the "goFunction" will call the callback function available in the second argument which is the same
 * function defined in fields.callback or the first argument passed to the "go" function.
 *
 * The "go" method can receive two callback arguments: "success" and "fail" which will override the initial callbacks
 * defined during the creation and will be continue to be used in the next execution of the "go" function.
 *
 * If a callback is not provided nor in the fields.callback or as first argument of the "go" call,
 * then the "go" function will return a Promise, otherwise this function will return undefined.
 *
 * @example
 * ```js
 * var properties = {
 *   city: {},
 *   country: {}
 * }
 * var defaults = {city: 'Lima', country: 'Peru'};
 * function sendToBackend(properties, callback) {
 *   // Ajax call sending the properties
 *   // ...
 *   callback("OK");
 * }
 * function onSuccess() {};
 * function onfail() {};
 *
 * var config = require('chain')(properties, sendToBackend, defaults);
 *
 * // Calling "go" passing callbacks
 * config.go(onSuccess, onfail);
 *
 * // Calling go and receive a Promise
 * config.go()
 *   .then(onSuccess)
 *   .catch(onFail);
 * ```
 *
 * Do you think this was difficult to read? Believe me, the most difficult was to write it.
 * @private
 * @class Chain
 * @module Services
 * @constructor
 * @param {Object}   fields
 * @param {Function} fields.callback Default callback function to be executed by "goFunction" function
 * @param {Function} fields.fail Default fail function callback to be executed by "goFunction" function
 * @param {Function} [goFunction] Should have the signature: function(properties, callback): Promise|undefined
 * @param {Object}   [options] Object with the initial values for the properties defined in the "fields" argument
 * @param {Function} [options.fail] Failsafe "fail" function to be executed by "goFunction" callback argument.
 *                                  It will override "fields.fail" (yeah, don't ask me why)
 */

/**
 * Executes a predefined asynchronous task using the current configuration and then execute one of
 * the callback functions based on the success of the result.
 *
 * It receives two optional arguments. The first one is a callback function that will be used when
 * the task is successfully completed. The second one is another callback function
 * that will be used only in case of failure.
 *
 * Both arguments are shortcuts for the <b>callback</b> and <b>fail</b> methods respectively.
 *
 * @example
 * All the ways of using this method:
 * ```js
 * // Defining callbacks as function arguments
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .go(successCallback, failureCallback);
 *
 * // Defining callbacks using setters methods
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .callback(successCallback)
 *   .fail(failureCallback)
 *   .go();
 *
 * // Using the returned Promise
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .go()
 *   .then(successCallback)
 *   .catch(failureCallback);
 * ```
 * The SDK provides a Promise polyfill for browsers (IE<9) without native ECMAScript 6 support.
 *
 * @method go
 * @param {Function} [success] The callback function to be called on case of success
 * @param {Function} [fail] The callback function to be called on case of failure.
 *     If a success callback was not given this argument will be ignored. In that case the returned Promise
 *     should be used to handle the failures.
 * @return {Promise|null} If the success callback is omitted (and wasn't defined one yet) this function
 *     will return a Promise
 */

/**
 * Sets or gets the value of the option `callback`.
 *
 * This callback function will be called only after the <b>go</b> method successfully complete its task.
 *
 * Its first and unique argument passed to the callback will be the result of the request.
 *
 * @example
 * ```js
 * function callbackFn(results) {
 *   console.log(results);
 * }
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .callback(callbackFn)
 *   .go();
 * ```
 *
 * @method callback
 * @chainable
 * @param {Function} [newValue] The new callback function
 * @throws {TypeError} If the given argument is not a function
 * @return {Function} The same service instance or the current callback function if no argument was given
 */

/**
 * Sets or gets the value of the option `fail`.
 *
 * This function is called when an error occurs (e.g. invalid values or a communication error).
 *
 * The callback will receive just one argument which is the error description.
 *
 * This parameter will be ignored if the callback function is not defined and therefore the
 * <b>go</b> method will return a Promise that will be rejected if an error occurs.
 *
 * If you don't specificy a failure callback, the default behavior in case of encounter a problem is to
 * throw an error.
 *
 * @example
 * ```js
 * function successCallback(results) {
 *   console.log(results);
 * }
 * function failureCallback(error) {
 *   console.log(error);
 * }
 * tomtom.fuzzySearch()
 *   .query("pizza")
 *   .callback(successCallback)
 *   .fail(failureCallback)
 *   .go();
 * ```
 *
 * @method fail
 * @chainable
 * @param {Function} [newValue] The new callback function
 * @throws {TypeError} If the given argument is not a function
 * @return {Function} The same service instance or the current callback function if no argument was given
 */
/* jshint nomen:false */
define(['./utils',
    'config/language/globalLocaleService',
    'config/language/validator',
    'config/geopolView/globalGeopolViewService',
    'config/geopolView/validator',
    'config/geopolView/geopolView',
    'common/parameterApplications'
],
function(utils,
    globalLocaleService,
    localeValidator,
    globalGeopolViewService,
    geopolViewValidator,
    GeopolView,
    parameterApplications) {
    'use strict';
    function checkIsFunction(fun) {
        if (typeof fun !== 'function') {
            throw new TypeError('a function is expected, but ' + fun + ' [' + typeof fun + '] given');
        }
        return fun;
    }

    function isUndefined(value) {
        return value === undefined;
    }

    function isFunction(converter) {
        return typeof converter === 'function';
    }

    function chain(data, name, value, validator, converter) {
        var options = {
            data: data,
            name: name
        };

        if (isUndefined(value)) {
            return isUndefined(data[name]) ? null : data[name];
        }
        if (isFunction(converter)) {
            value = converter.call(this, value, options);
        }
        if (isFunction(validator)) {
            value = validator.call(this, value, options);
        }
        data[name] = value;
        return this;
    }

    function checkRequired(fields, data) {
        var field, fieldName;
        for (field in fields) {
            if (fields.hasOwnProperty(field)) {
                fieldName = fields[field].name || field;
                if (fields[field].required === true && !data.hasOwnProperty(fieldName)) {
                    throw new Error('Missing required ' + field);
                }
            }
        }
    }

    function runPostValidators(fields, data) {
        var field;
        var that = this;
        function callValidator(validator) {
            validator.call(that, data[field], data, field);
        }
        for (field in fields) {
            if (fields.hasOwnProperty(field)) {
                if (utils.isArray(fields[field].postValidator)) {
                    fields[field].postValidator.forEach(callValidator);
                } else if (!isUndefined(fields[field].postValidator)) {
                    fields[field].postValidator.call(this, data[field], data, field);
                }
            }
        }
    }

    function createFunction(f, fields, data) {
        return function(value) {
            var fieldName = fields[f].name || f;
            return chain.call(this, data, fieldName, value, fields[f].validator, fields[f].converter);
        };
    }

    function setLanguageIfNeeded(data) {
        var serviceType = data.__serviceType;
        var locale;
        if (!serviceType || data.language && localeValidator(data.language, serviceType)) {
            return;
        }
        locale = globalLocaleService.getCurrentLocale();
        data.language = locale.getValueFor(serviceType);
    }

    function setGeopolViewIfNeeded(data) {
        var geopolView;
        var serviceType = data.__serviceType;
        var supportedServices = GeopolView.getSupportedServices();
        if (!serviceType ||
            supportedServices.indexOf(serviceType) === -1 ||
            (data.view && geopolViewValidator(data.view, serviceType))) {
            return;
        }
        geopolView = globalGeopolViewService.getCurrentGeopolView();
        data.view = geopolView.getValueFor(serviceType);
    }

    return function(fields, goFunction, options) {
        var data = {},
            that = this,
            service,
            field;
        options = options || {};
        data.__serviceType = options.__serviceType;
        setLanguageIfNeeded(options);
        setGeopolViewIfNeeded(options);
        fields.callback = {
            validator: checkIsFunction
        };
        fields.fail = {
            validator: checkIsFunction,
            defaultValue: function(e) {
                if (utils.isObject(e)) {
                    e = JSON.stringify(e);
                }
                console.error(e || 'Unknown Error');
                throw new Error(e || 'Unknown Error');
            },
            application: parameterApplications.OTHER
        };

        service = {
            go: function(success, fail) {
                var callback;
                if (success) {
                    data.callback = checkIsFunction(success);
                }
                if (fail) {
                    data.fail = checkIsFunction(fail);
                }
                checkRequired(fields, data);
                runPostValidators(fields, data);
                if (data.callback) {
                    callback = data.callback;
                    delete data.callback;
                    goFunction.call(that, utils.clone(data), callback);
                    return undefined;
                } else {
                    return new Promise(function(resolve, reject) {
                        data.fail = function(error) {
                            reject(error);
                        };
                        goFunction.call(that, utils.clone(data), function(response) {
                            resolve(response);
                        });
                    });
                }
            }
        };

        for (field in fields) {
            if (fields.hasOwnProperty(field)) {
                service[field] = createFunction(field, fields, data);
                if (!isUndefined(fields[field].defaultValue)) {
                    service[field].call(this, fields[field].defaultValue);
                }
                // if options were passed initialize the data
                if (options && options.hasOwnProperty(field)) {
                    service[field].call(this, options[field]);
                }

                if (fields[field].visible === false) {
                    delete service[field];
                }
            }
        }
        if (options && options.fail) {
            data.fail = options.fail;
        }
        return service;
    };
});



// WEBPACK FOOTER //
// ./services/chain.js